// extracted by mini-css-extract-plugin
export default {"mapHeaderInput":"MapSection_mapHeaderInput__MKWRU","mapSizeInput":"MapSection_mapSizeInput__XdOCM","textFieldContainer":"MapSection_textFieldContainer__SRGwm"};